/**
 * Determine if two strings are equal in a case-insensitive way.
 * @param first The first string to compare.
 * @param second The second string to compare.
 * @returns True if the strings are equal, ignoring case; false otherwise.
 */
export function equals(first: string, second: string) {
  return first.localeCompare(second, undefined, { sensitivity: 'base' }) === 0
}
